///<reference path="../../node_modules/@types/react-dom/index.d.ts"/>
import * as React from "react";
import {backgrounds, materialGroup, RenderEngine, renderSettings, visibilitySet} from "../Controller/3DController/RenderEngine";
import './App.css'
import './MenuButton.css'
import {isMobile, isIOS, isSafari} from "react-device-detect";
import { SelectionController } from "../Controller/3DController/SelectionController";
import { ARCannotActivateError, ARController } from "../Controller/ARController/ARController";
import {MenuMobile} from "./MenuMobile/MenuMobile";
import {Controller3D} from "../Controller/3DController/3DController";
import {ConfiguratorModel} from "../Controller/3DController/ConfiguratorModel";
import { HotspotController, IHotspotData, loadHotspots } from "../Controller/3DController/HotspotController";
import {Menu} from "./Menu/Menu";
import {string} from "prop-types";
import MediaQuery from 'react-responsive';
import { DeviceOrientationCameraController } from "../Controller/3DController/DeviceOrientationCameraController";
import { CarModelCameraList, ModelLoadController } from "../Controller/3DController/ModelLoad/ModelLoadController";
import {Tutorial} from "./tutorial/Tutorial";
import {Transition, TransitionGroup, CSSTransition} from "react-transition-group"
import { MenuMain } from "./MenuMain/MenuMain";
import { MenuMain as MenuMainNew } from "./NewUI/MenuMain/MenuMain";
import {timeout} from "q";
const QRCode = require("qrcode");
import thumb from '../../background/Slider_thumb.svg'
import { Disclaimer } from "./Disclaimer/Disclaimer";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { getCookie } from "../Controller/ulti";
import { Simulate } from "react-dom/test-utils";
import { ScreenshotController } from "../Controller/3DController/ScreenshotController";
import { WebShareController } from "../Controller/3DController/WebShareController";
import { Screenshot } from "./screenshot/Screenshot";
import { Screenshot as ScreenshotNew } from "./NewUI/Screenshot/Screenshot";
import { ModelChange } from "./ModelChange/ModelChange";
import { ModelChange as ModelChangeNew } from "./NewUI/ModelChange/ModelChange";
import { setTrackConfiguratorModel, trackARLoad, trackDriving, trackLoad, trackModelChange} from "../Controller/Tracking";
import { TrunkLoadingController } from "../Controller/3DController/TrunkLoadingController";
import { TrunkLoading } from "./TrunkLoading/TrunkLoading";
import { TrunkLoading as TrunkLoadingNew } from "./NewUI/TrunkLoading/TrunkLoading";
import { GenericPassenger } from "./GenericPassenger/GenericPassenger";
import { GenericPassenger as GenericPassengerNew } from "./NewUI/GenericPassenger/GenericPassenger";
import { GenericPassengerController } from "../Controller/3DController/GenericPassengerController";
import { XRayController } from "../Controller/3DController/XRayController";
import { XRay } from "./XRay/XRay";
import { XRay as XRayNew } from "./NewUI/XRay/XRay";
import { getWhiteLabel } from "../whitelabel";
import { ChevronLeft, ChevronRight, Close } from './NewUI/Icons/Icons';
import { XREngine, XRStatus } from "../Controller/ARController/XREngine";
import { CaptureController } from "../Controller/3DController/CaptureController";
import { AudioController } from "../Controller/3DController/AudioController";
import { EventController } from "../Controller/3DController/Event/EventController";
import { SequenceController } from "../Controller/3DController/SequenceController";
import { getUrlData } from "../urlData";

//export const landing = "https://clients.viscircle.com/volkswagen-landing/";
export const landing = "https://clients.viscircle.com/volkswagen-landing-dev/";

interface Props{

}

interface State{
    engine: RenderEngine,
    selectionController:SelectionController,
    arController:ARController,
    controller3D:Controller3D,
    modelController:ConfiguratorModel,
    hotspotController:HotspotController,
    hotspotData:{ car:string, data:IHotspotData[]}[],
    deviceOrientationCameraController:DeviceOrientationCameraController,
    screenshotController:ScreenshotController,
    webShareController:WebShareController,
    trunkLoadingController:TrunkLoadingController,
    genericPassengerController:GenericPassengerController,
    xRayController:XRayController,
    captureController:CaptureController,
    audioController:AudioController,
    eventController:EventController,
    sequenceController:SequenceController,
    materialGroup: any[],
    backgrounds: any[],
    visibilitySet: any[],
    renderSetting:any[],
    menuOn:boolean,
    presentation:boolean,
    presentext:string,
    endlogo:boolean,
    video:any,
    QRlink:string,
    highlightAR:boolean,
    warning:boolean,
    content:number,
    groundHotspot:boolean,
    loading:boolean,
    loadingAnim:boolean,
    disclaimer:boolean,
    mediaQueryIpad:boolean,
    maxHeight:string,
    test:number,
    textHide:boolean,
    fadein:boolean,
    loadProgress:number,
    hotspotAnim:boolean,
    driving:boolean,
    screenshot:boolean,
    modelSelect:boolean,
    trunkLoading:boolean,
    genericPassenger: boolean,
    xRay: boolean
    exporting:boolean;
    xrActive:boolean;
    sequence:boolean;
    sequenceText:string;
    sequenceTextFadeIn:boolean;
    sequenceTextFadeOut:boolean;
    sequenceTextPosition:string;
    sequenceTextOffsetLeft:number;
    isModelLoadIntroAnimationRunning:boolean;
}

export class App extends React.Component<Props,State> {
    constructor(props:Props){
        super(props);
        const engine: RenderEngine = new RenderEngine();
        const audioController = new AudioController();
        const selectionController = new SelectionController(engine, isMobile);
        const controller3D = new Controller3D(engine, audioController);
        const arController = new ARController(engine);
        const webShareController = new WebShareController();
        const genericPassengerController = new GenericPassengerController(controller3D);

        let vh = window.innerHeight.toString();
        this.originalSize = window.innerHeight;
        this.state = {
            engine: engine,
            selectionController: selectionController,
            arController: arController,
            controller3D: controller3D,
            modelController:null,
            hotspotController:null,
            hotspotData: [],
            deviceOrientationCameraController: null,
            screenshotController: null,
            trunkLoadingController:null,
            webShareController: webShareController,
            // TODO12 might chage to null, wait for init engine
            genericPassengerController: genericPassengerController,
            xRayController: null,
            eventController: null,
            sequenceController: null,
            materialGroup: [],
            backgrounds: [],
            visibilitySet:[],
            renderSetting:[],
            menuOn:true,
            presentation:false,
            presentext:"",
            endlogo:false,
            video:null,
            QRlink:"",
            highlightAR:false,
            warning:false,
            content:0,
            groundHotspot:false,
            loading:true,
            /* Force show disclaimer when a config is loaded,
             * because otherwise we miss the user legitimization for playing sound
             * when the config is loaded right away with no model switch or disclaimer dialog.
             */
            disclaimer:!(getCookie("disclaimer") === "true" && !getUrlData().config),
            loadingAnim:true,
            mediaQueryIpad: window.matchMedia('(min-aspect-ratio: 1/1)').matches,
            maxHeight:"100vh",
            test:0,
            textHide:false,
            fadein:false,
            loadProgress:0,
            hotspotAnim:false,
            driving:false,
            screenshot:false,
            modelSelect:false,
            trunkLoading:false,
            genericPassenger: false,
            xRay: false,
            exporting:false,
            xrActive: false,
            captureController: null,
            audioController: audioController,
            sequence: false,
            sequenceText: "",
            sequenceTextFadeIn: false,
            sequenceTextFadeOut: false,
            sequenceTextPosition: "bottom",
            sequenceTextOffsetLeft: 0,
            isModelLoadIntroAnimationRunning: false
        }
        window.onresize = this.fullScreen.bind(this)
    }

    private originalSize;

    private timeoutfullscreen;

    private initial = true;

    private getHotspots():IHotspotData[]{
        const name = this.state.modelController.modelLoadController.currentModelName;
        console.log("Requesting hotspots for", name, "Available hotspots:", this.state.hotspotData.map(h => h.car));
        const data = this.state.hotspotData.find(k => k.car===name);
        return data ? data.data : [];
    }

    private fullScreen(){
        let vhnew = window.innerHeight;
        if(!isMobile){
            this.setState({
                maxHeight:vhnew+"px"
            })
            return;
        }
        if(vhnew > this.originalSize){
            this.setState({
                maxHeight:"100vh"
            })
            return;
        }
        this.setState({
            maxHeight:vhnew.toString()+"px"
        })
    }

    componentDidMount() {
        let vh = window.innerHeight.toString();
        this.setState({
            maxHeight:vh+"px"
        })
        let el = document.getElementById("main-holder");
        el.addEventListener("wheel", (e)=>{
            e.preventDefault();
        }, {passive:false})
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
        setTimeout(()=>{
            this.setState({
                fadein: true

            })}, 500);
        setTimeout(()=>{
            this.setState({
                textHide: true

            })}, 5000);
        if(!this.state.disclaimer){
            this.load()
        }

        this.state.arController.xrEngine.event.on(XREngine.EVENT_STATUS_CHANGE, (status:XRStatus) => {
            this.setState({xrActive: this.state.arController.active});
        })

        ModelLoadController.event.on(ModelLoadController.EVENT_ANIMATION_START_STOP, (running:boolean) => {
            this.setState({
                isModelLoadIntroAnimationRunning: running
            });
        });
    }

    onEnterAR = (leaveTrunkOpen:boolean = false):void => {
        if (isIOS && !isSafari) {
            alert(`Augmented Reality on iOS is supported only in Safari. Please open this webpage in Safari to use AR.`)
            return;
        }
        
        trackARLoad();
        this.setState({exporting:true});

        this.state.arController.enterAR(leaveTrunkOpen).then(() => {
            this.setState({exporting:false});
        }).catch((error) => {
            this.setState({exporting:false});
            if (error instanceof ARCannotActivateError) {
                alert(
                    `AR is not supported on your device or browser.
Please use Google Chrome 88 or higher and install the Google Play Services for AR from the Android Play Store.`);
            } else {
                console.error("Unspecified AR error:", error);
                alert("Sorry, something went wrong. Please try again.");
            }
        });
    }

    onLeaveAR = ():void => {
        if (this.state.arController.active) {
            this.state.arController.leaveAR();
        }
    }

    private load = async () => {
        this.fakeLoading = setInterval(()=>{
            let i = this.state.loadProgress + 0.05;
            if (i >= 0.5){
                clearInterval(this.fakeLoading);
                return;
            }
            this.setState({
                loadProgress: i
            })
        }, 200);

        await this.state.engine.initEngine();
        
        const eventController = new EventController();
        const deviceOrientationCameraController = new DeviceOrientationCameraController(
            this.state.engine.engine,
            this.state.controller3D);
        const modelController = new ConfiguratorModel(this.state.engine, this.state.controller3D, deviceOrientationCameraController, eventController);
        const hotspotController = new HotspotController(this.state.engine, this.state.controller3D, this.state.selectionController, this.state.controller3D.animationController, modelController);
        const hotspotData = await loadHotspots();
        const trunkLoadingController = new TrunkLoadingController(this.state.controller3D, eventController);
        const xRayController = new XRayController(this.state.controller3D, modelController);

        const sequenceController = new SequenceController(modelController, hotspotController, (text:string, timeout:number, fade:boolean, position:string) => {
            if (fade) {
                this.setState({
                    sequenceText: "",
                    sequenceTextFadeIn: false,
                    sequenceTextFadeOut: false,
                    sequenceTextPosition: position,
                    sequenceTextOffsetLeft: 0
                });

                setTimeout(() => {
                    this.setState({
                        sequenceText: text,
                        sequenceTextFadeIn: true
                    });
                }, 64);

                setTimeout(() => {
                    this.setState({
                        sequenceTextFadeIn: false
                    });
                    setTimeout(() => {
                        this.setState({
                            sequenceTextFadeOut: true
                        });
                    }, 64);
                }, Math.max(0, timeout - 1000));

                if (position == "center") {
                    const timestampBegin = performance.now();

                    const onFrame = () => {
                        const timestampNow = performance.now();
                        const percent = (timestampNow - timestampBegin) / timeout;
                        const percentClamp = Math.min(percent, 1);
                        const offsetMin = -20;
                        const offsetMax = 0;

                        this.setState({
                            sequenceTextOffsetLeft: offsetMin + (offsetMax - offsetMin) * Math.pow(percentClamp, 1/8)
                        });

                        if (percent < 1) {
                            requestAnimationFrame(onFrame);
                        }
                    };

                    requestAnimationFrame(onFrame);
                }
            } else {
                this.setState({
                    sequenceText: text,
                    sequenceTextFadeIn: false,
                    sequenceTextFadeOut: false,
                    sequenceTextPosition: position
                });

                setTimeout(() => {
                    this.setState({
                        sequenceText: ""
                    })
                }, timeout)
            }
        });

        sequenceController.event.on(SequenceController.EVENT_START, () => {
            this.setState({
                sequence: true
            });
        });
        sequenceController.event.on(SequenceController.EVENT_STOP, () => {
            this.setState({
                sequence: false
            });
        });

        setTrackConfiguratorModel(modelController, this.state.controller3D);

        this.state.arController.initialize(modelController, hotspotController, deviceOrientationCameraController, eventController);
        this.state.controller3D.initialize(this.state.arController);
        this.state.selectionController.initialize(
            modelController,
            this.state.controller3D,
            trunkLoadingController,
            this.state.genericPassengerController, xRayController, sequenceController
        );
        modelController.initialize();
        xRayController.initialize();

        this.state.audioController.initialize(this.state.engine);

        const screenshotController = new ScreenshotController(this.state.engine, modelController.modelLoadController);

        // The instance is not saved anywhere yet,
        // but the capture controller will expose itself on the global Window object,
        // so that you can call methods on it via the console.
        const captureController = new CaptureController(this.state.engine, modelController.modelLoadController);
    
        await eventController.initialize(getUrlData().previewEventName);

        // Enable audio by default if an event is active.
        if (eventController.areAnyEventsActive) {
            this.state.audioController.muted = false;
        }

        this.setState({
            modelController,
            hotspotController,
            hotspotData,
            deviceOrientationCameraController,
            screenshotController,
            trunkLoadingController,
            xRayController,
            eventController,
            sequenceController,
            materialGroup,
            backgrounds,
            visibilitySet,
            renderSetting: renderSettings
        }, ()=>{
            ModelLoadController.event.on("loading", (e)=>{
                if(e <= this.state.loadProgress){
                    return
                }

                if (e <= 0.995) {
                    this.setState({
                        loadProgress:e
                    })
                }
            })

            ModelLoadController.event.on("loaded", (e)=>{
                hotspotController.clearBindings();
                this.getHotspots().forEach((h)=>{
                    hotspotController.bindHotspot(h.hotspotName, ()=>{
                        this.toogleInfo(h.name)
                    })
                    h.content.forEach((c)=>{
                        this.preloadImage(c.picture)
                    })
                })
                hotspotController.bindHotspotClose(() => {
                    this.setState({
                        video: "none"
                    })
                })

                if(this.initial){
                    trackLoad();
                    this.initial = false;
                }
                else {
                    trackModelChange()
                }

            })

            this.state.selectionController.setShowDisclaimerCallback(()=>{
                this.setState({disclaimer:true})
            });

            if (getUrlData().config) {
                modelController.setConfig(getUrlData().config).then(() => {
                    this.setState({
                        loadProgress: 1,
                        loadingAnim: false
                    });

                    if (getUrlData().highlightAR) {
                        this.setState({
                            highlightAR:true
                        })
                    }
                });
            } else {
                // No config or car model provided - show model selection!
                this.setState({
                    modelSelect: true,
                    loading: false,
                    loadProgress: 1,
                    loadingAnim: false
                });
            }
        })

        this.setState({warning: this.state.modelController.checkUnavailable()});
        ConfiguratorModel.event.on('selection', () => {
            this.setState({warning: this.state.modelController.checkUnavailable()})
        });
        Controller3D.event.on('changedCam', ()=>{
            let b = this.state.controller3D.isGroundHotspot();
            this.setState({
                groundHotspot: b
            })
        })
    }

    private fakeLoading;

    private preloadImage(url)
    {
        var img=new Image();
        img.src=url;
    }

    handleClickOutside(event) {
        let inside = false;
        if(!event){
            return;
        }
        if(!event.path){
            if(!event.target && !event.target.parentNode){
                return;
            }
            if(event.target.parentNode.className === "hotspot-text-holder" || event.target.parentNode.className === "hotspot-panel" || event.target.parentNode.className === "pop-up-image-slider"){
                inside = true;
            }
        }
        else {
            for(let i = 0; i < event.path.length; i++){
                if(event.path[i].className === "hotspot-information" || event.path[i].className === "hotspot-panel" || event.path[i].className === "pop-up-image-slider"){
                    inside = true;
                    break;
                }
            }
        }
        if(!inside && this.state.video){
            // if(this.state.video.type === "text"){
            //     this.setState({
            //         video:false
            //     })
            // }
            this.setState({
                hotspotAnim:false
            })
        }
    }

    private getSequenceLabelClasses(className:string):string {
        if (this.state.sequenceTextFadeIn) {
            // if (this.state.sequenceTextPosition == "center") {
                // className += " sequence-label-fadein-with-shift"; 
            // } else {
                className += " sequence-label-fadein";
            // }
        }

        if (this.state.sequenceTextFadeOut) {
            className += " sequence-label-fadeout";
        }

        return className;
    }

    private renderSequenceCenterLabel() {
        if (this.state.sequence && this.state.sequenceTextPosition == "center") {
            const className = this.getSequenceLabelClasses("sequence-center-label");

            return (
                <div
                    className={className}
                    style={{position: 'relative', left: `${this.state.sequenceTextOffsetLeft}vw`}}
                    dangerouslySetInnerHTML={{ __html: this.state.sequenceText }}
                />
            );
        }

        return undefined;
    }

    private renderSequenceMenu() {
        if (this.state.sequence) {
            const className = this.getSequenceLabelClasses("sequence-label");

            return(
                <div className={"vw-ground-holder"}>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        {this.state.sequenceTextPosition == "bottom" &&
                            (<div className={className}>{this.state.sequenceText}</div>)
                        }
                        <div className="vw-ground">
                            <div className={"vw-ground-button exit"} onClick={()=>{this.state.sequenceController.stop()}}>
                                <Close />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return undefined;
    }

    getMenu(){
        const xrActive = this.state.xrActive;

        if(this.state.disclaimer){
            return "";
        }
        if(this.state.driving){
            return(
                <>
                    <div className={"vw-ground"}>
                        {!xrActive && (
                            <div
                                className={"vw-ground-button"}
                                onClick={()=>{this.state.modelController.drivingAnimationController.rotateCamLeft()}}
                            >
                                <ChevronLeft />
                            </div>
                        )}
                        <div
                            className={"vw-ground-button exit"}
                            onClick={()=>{
                                this.state.modelController.drivingAnimationController.stop();
                                this.setState({
                                    driving:this.state.modelController.drivingAnimationController.enabled
                                })
                            }}
                        >
                            <Close />
                        </div>

                        {!xrActive && (
                            <div
                                className={"vw-ground-button"}
                                onClick={()=>{this.state.modelController.drivingAnimationController.rotateCamRight()}}
                            >
                                <ChevronRight />
                            </div>
                        )}
                    </div>
                    {/* <MediaQuery minWidth={950}>
                        <div className={"ground-off-holder"}>
                            {!xrActive && <div className={"ground-off"} onClick={()=>{this.state.modelController.drivingAnimationController.rotateCamLeft()}}><img src={`./${HASH}/Icons_Png/Arrow_Left.svg`}/></div>}
                            <div className={"ground-off"} onClick={()=>{
                                this.state.modelController.drivingAnimationController.stop();
                                this.setState({
                                    driving:this.state.modelController.drivingAnimationController.enabled
                                })
                            }
                            }><img src={`./${HASH}/Icons_Png/Exit_a.svg`}/></div>
                            {!xrActive && <div className={"ground-off"} onClick={()=>{this.state.modelController.drivingAnimationController.rotateCamRight()}}><img src={`./${HASH}/Icons_Png/Arrow_Right.svg`}/></div>}
                        </div>
                    </MediaQuery> */}
                </>
            )
        }
        if(this.state.groundHotspot){
            return(
                <>
                    <MediaQuery maxWidth={950}>
                        <div className={"vw-ground"}>
                            <div className={"vw-ground-button"} onClick={()=>{this.state.selectionController.groundHotspotRotateLeft()}}><ChevronLeft /></div>
                            <div className={"vw-ground-button exit"} onClick={()=>{this.state.selectionController.exitGroundHotspot()}}><Close /></div>
                            <div className={"vw-ground-button"} onClick={()=>{this.state.selectionController.groundHotspotRotateRight()}}><ChevronRight /></div>
                        </div>
                    </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <div className={"ground-off-holder"}>
                            <div className={"ground-off"} onClick={()=>{this.state.selectionController.groundHotspotRotateLeft()}}><img src={`./${HASH}/Icons_Png/Arrow_Left.svg`}/></div>
                            <div className={"ground-off"} onClick={()=>{this.state.selectionController.exitGroundHotspot()}}><img src={`./${HASH}/Icons_Png/Exit_a.svg`}/></div>
                            <div className={"ground-off"} onClick={()=>{this.state.selectionController.groundHotspotRotateRight()}}><img src={`./${HASH}/Icons_Png/Arrow_Right.svg`}/></div>
                        </div>
                    </MediaQuery>
                </>
            )
        }
        if(this.state.screenshot) {
            return (
                <>
                    <MediaQuery maxWidth={950}>
                        <ScreenshotNew screenshotService={this.state.screenshotController} shareService={this.state.webShareController} modelController={this.state.modelController} xrActive={this.state.xrActive} closeScreenshot={()=>{this.setState({screenshot:false})}}/>
                    </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <ScreenshotNew screenshotService={this.state.screenshotController} shareService={this.state.webShareController} modelController={this.state.modelController} xrActive={this.state.xrActive}  closeScreenshot={()=>{this.setState({screenshot:false})}}/>;
                    </MediaQuery>
                </>
            );
        }
        if(this.state.modelSelect){
            return(
                <>
                    <MediaQuery maxWidth={950}>
                        <ModelChangeNew
                            close={()=>{this.setState({modelSelect:false})}}
                            configuratorModel={this.state.modelController}
                        />
                    </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <ModelChangeNew
                            close={()=>{this.setState({modelSelect:false})}}
                            configuratorModel={this.state.modelController}
                        />
                    </MediaQuery>
                </>
            )
        }
        if(this.state.trunkLoading){
            return(
                <>
                    <MediaQuery minWidth={950}>
                        <TrunkLoadingNew trunkLoadingController={this.state.trunkLoadingController}
                            exit={() => {
                                this.state.trunkLoadingController.leave();
                                this.setState({trunkLoading:false})
                            }}
                            exporting={this.state.exporting}
                            onEnterAR={this.onEnterAR}
                        />
                    </MediaQuery>
                    <MediaQuery maxWidth={950}>
                        <TrunkLoadingNew trunkLoadingController={this.state.trunkLoadingController}
                            exit={() => {
                                this.state.trunkLoadingController.leave();
                                this.setState({trunkLoading:false})
                            }}
                            exporting={this.state.exporting}
                            onEnterAR={this.onEnterAR}
                        />
                    </MediaQuery>
                </>
            )
        }
        if(this.state.genericPassenger){
            return(
                <>
                    <MediaQuery maxWidth={950}>
                        <GenericPassengerNew
                            genericPassengerController={this.state.genericPassengerController}
                            exit={() => {
                                this.state.genericPassengerController.leave();
                                this.setState({genericPassenger: this.state.genericPassengerController.active})
                            }}
                        />
                    </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <GenericPassengerNew
                            genericPassengerController={this.state.genericPassengerController}
                            exit={() => {
                                this.state.genericPassengerController.leave();
                                this.setState({genericPassenger: this.state.genericPassengerController.active})
                            }}
                        />
                    </MediaQuery>
                </>
            )
        }
        if(this.state.xRay){
            return(
                <>
                    <MediaQuery maxWidth={950}>
                        <XRayNew xRayController={this.state.xRayController} exit={()=>{this.state.xRayController.leave(); this.setState({xRay:false})}} />
                    </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <XRayNew xRayController={this.state.xRayController} exit={()=>{this.state.xRayController.leave(); this.setState({xRay:false})}} />
                    </MediaQuery>
                </>
            )
        }
        if(this.state.sequence){
            return this.renderSequenceMenu();
        }
        else {return ("")}
    }

    getLogo(){
      if(this.state.endlogo){
          return(
              <div className="presentation logo">
                  <img src={require('./vwlogo2.png')} style={{ marginRight: "0.5em" }}/>
                  <img src={require('./vwlogo.png')}/>
              </div>
          )
      }
      else {
          return"";
      }
    }

    toogleMenu(){
      let b = !this.state.menuOn;
      this.setState({
          menuOn: b
      },()=>{this.state.engine.resize()})
    }

    toogleInfo(info:string){
        let content = this.getHotspots().find(e => e.name === info);
        if(!content){
            return;
        }
        if(!this.state.video){
            this.setState({
                video: content
            },()=>{
                this.setState({
                    hotspotAnim:true
                })
            })
        }
        else if(this.state.video != content){
            this.setState({
                video: null,
                hotspotAnim:false
            },()=>{
                this.setState({
                    video: content
                }, ()=>{
                    this.setState({
                        hotspotAnim:true
                    })
                })
            })
        }
        else {
            this.setState({
                hotspotAnim:false,
                video:null
            })
        }
    }

    isMenu():boolean{
      return (this.state.menuOn && !this.state.presentation);
    }

    appendHotspot(){
        let div = document.createElement("div");
        const newContent = document.createTextNode("Tap on the car to change color.");
        div.appendChild(newContent);
        this.state.hotspotController.addContentDiv("Test", div)
    }

    //-------------------------------------------------------------------
    private dragging = false;
    private x = -200;
    private onMouseDown (e) {
        if(!this.state.video){
            return;
        }
        this.x = e.clientX?e.clientX:e.touches[0].pageX;
        this.dragging = true;
    }

    private onMouseMove (e) {
        if(!this.state.video){
            return;
        }
        let distance = e.clientX?e.clientX:e.touches[0].pageX;
        if (!this.dragging) {
            return;
        }
        if(((distance- this.x) <= -10) && ((distance - this.x) >= -50)){
            this.dragging = false;
            this.x = -200;
            let index = this.state.content + 1;
            if(index > this.state.video.content.length-1){
                index = 0;
            }
            this.setState({content:index})
        }
        else if(((distance- this.x) >= 10) && ((distance - this.x) <= 50)){
            this.dragging = false;
            this.x = -200;
            let index = this.state.content - 1;
            if(index < 0){
                index = this.state.video.content.length-1;
            }
            this.setState({content:index})
        }
    }

    private onMouseUp (e) {
        if(!this.state.video){
            return;
        }
        this.dragging = false;
        this.x = -200;
        // do your end of dragging stuff
    }

    //-------------------------------------------------------------------

    generateQR(){
        if(this.state.video === "QR"){
            return;
        }
        const url = this.state.modelController.getConfigURL(true);
        QRCode.toDataURL(url).then((url:string) => {
            this.setState({
                QRlink: url,
                video:"QR"
            }, ()=>{
                this.setState({
                    hotspotAnim:true
                })
            })
        });
    }

    setText(s:string){
      this.setState({presentext:s});
    }
    turnOnLogo(){
        this.setState({endlogo:true});
    }

    endPresentation(){
        this.setState({presentation:false, endlogo:false}, ()=>{
            this.state.modelController.reset3D()
            if(isMobile){
                this.state.engine.changeRenderSetting(this.state.renderSetting[0].id)
            }
            else{
                this.state.engine.changeRenderSetting(this.state.renderSetting[1].id)
            }
        })
    }

    presentation(){
        // this.setState({presentation:true})
        // this.state.controller3D.presentation();
    }


    getLoading(){
        const loadingPercentage = () => {
            const currentProgress = Math.round(100 * this.state.loadProgress);

            if (currentProgress === 0) {
                return '100%';
            } else if (currentProgress > 0 && currentProgress <= 20) {
                return '83%';
            } else if (currentProgress > 20 && currentProgress <= 38) {
                return '66%';
            } else if (currentProgress > 38 && currentProgress <= 55) {
                return '49%';
            } else if (currentProgress > 55 && currentProgress <= 82) {
                return '32%';
            } else if (currentProgress > 82 && currentProgress <= 99) {
                return '15%';
            } else if (currentProgress > 99) {
                return '0%';
            } else {
                return '100%';
            }
        };

        if(isMobile){
            return(
                <div className={"loading-screen"}>
                    {getWhiteLabel().name === 'ID. Studio'
                    ? (
                        <div className={"battery-loader-wrapper"}>
                            <div className={"battery-loader"}>
                                <div className={"battery-indicator"} style={{ clipPath: `polygon(0% 100%, 100% 100%, 100% ${loadingPercentage()}, 0% ${loadingPercentage()})`}}>
                                    <div className={"battery-cell"}/>
                                    <div className={"battery-cell"}/>
                                    <div className={"battery-cell"}/>
                                    <div className={"battery-cell"}/>
                                    <div className={"battery-cell"}/>
                                    <div className={"battery-cell"}/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={"loading-logo"}>
                                <img src={`./${HASH}/vwlogo.png`}/>
                            </div>
                            <span className={"loading-rail"}></span>
                            <CircularProgressbar className={"outer-ring"} value={this.state.loadProgress} maxValue={1} strokeWidth={2}/>
                            <CircularProgressbar className={"outer-ring outer-blur"} value={this.state.loadProgress} maxValue={1} strokeWidth={8}/>
                            <CircularProgressbar value={this.state.loadProgress} maxValue={1} strokeWidth={1}/>
                        </>
                    )}

                    <i className="loading-headline">{getWhiteLabel().name}</i>
                </div>
            )
        }
        else {
            return(
                <React.Fragment>
                    <MediaQuery minWidth={950}>
                        <div className={"loading-screen"}>

                            {getWhiteLabel().name === 'ID. Studio'
                            ? (
                                <div className={"battery-loader-wrapper"}>
                                    <div className={"battery-loader"}>
                                        <div className={"battery-indicator"} style={{ clipPath: `polygon(0% 100%, 100% 100%, 100% ${loadingPercentage()}, 0% ${loadingPercentage()})`}}>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={"loading-logo"}>
                                        <img src={`./${HASH}/vwlogo.png`}/>
                                    </div>
                                    <span className={"loading-rail"}></span>
                                    <CircularProgressbar className={"outer-ring"} value={this.state.loadProgress} maxValue={1} strokeWidth={2}/>
                                    <CircularProgressbar className={"outer-ring outer-blur"} value={this.state.loadProgress} maxValue={1} strokeWidth={8}/>
                                    <CircularProgressbar value={this.state.loadProgress} maxValue={1} strokeWidth={1}/>
                                </>
                            )}

                            <i className="loading-headline">{getWhiteLabel().name}</i>
                        </div>
                    </MediaQuery>
                    <MediaQuery maxWidth={950}>
                        <div className={"loading-screen"}>
                            {getWhiteLabel().name === 'ID. Studio'
                            ? (
                                <div className={"battery-loader-wrapper"}>
                                    <div className={"battery-loader"}>
                                        <div className={"battery-indicator"} style={{ clipPath: `polygon(0% 100%, 100% 100%, 100% ${loadingPercentage()}, 0% ${loadingPercentage()})`}}>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                            <div className={"battery-cell"}/>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={"loading-logo"}>
                                        <img src={`./${HASH}/vwlogo.png`}/>
                                    </div>
                                    <span className={"loading-rail"}></span>
                                    <CircularProgressbar className={"outer-ring"} value={this.state.loadProgress} maxValue={1} strokeWidth={2}/>
                                    <CircularProgressbar className={"outer-ring outer-blur"} value={this.state.loadProgress} maxValue={1} strokeWidth={8}/>
                                    <CircularProgressbar value={this.state.loadProgress} maxValue={1} strokeWidth={1}/>
                                </>
                            )}

                            <i className="loading-headline">{getWhiteLabel().name}</i>
                        </div>
                    </MediaQuery>
                </React.Fragment>
            )
        }
    }

    renderHotspotPopup(){
        if(this.state.video === "none"){
            return"";
        }
        return this.getInforContent()
    }
    getInforContent(){
        if(!this.state.video){
            return;
        }
        if(this.state.video.type === "test"){
            return(
                <div className={"video-pc youtube video"}>
                    <div className="video-close" onClick={()=>{this.setState({video:"none"})}}>&times;</div>
                    <div className="info-popup">
                        <iframe src="https://www.youtube.com/embed/wEYAytYeOdQ" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen></iframe>
                    </div>
                </div>

            )
        }
        else if(this.state.video.type === "video"){
            const hotspotText = this.state.video.content[this.state.content].text;

            return(
                <>
                    {/* <MediaQuery maxWidth={950}> */}
                        <CSSTransition in={this.state.hotspotAnim} classNames="vw-hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"vw-hotspot-panel vw-hotspot-panel-video"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="vw-hotspot-wrapper">
                                    <div className="vw-hotspot-image">
                                        {this.state.video.content.map((e)=>{
                                            return(
                                                <iframe src={e.picture} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            )
                                        })}
                                    </div>
                                    <div className={"vw-hotspot-information"}>
                                        <div className={"vw-hotspot-text-holder"}>
                                            <h6 className="vw-hotspot-header">{this.state.video.content[this.state.content].header}</h6>
                                            {
                                                Array.isArray(hotspotText) ? (
                                                    hotspotText.map(text => [
                                                        <p className="vw-hotspot-text">{text}</p>, <br/>
                                                    ])
                                                ) : (
                                                    <p className="vw-hotspot-text">{hotspotText}</p>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div
                                        className="vw-hotspot-close-button"
                                        onClick={() => this.setState({ hotspotAnim: false })}
                                    >
                                        <Close />
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    {/* </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"hotspot-panel hotspot-panel-video"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="pop-up-image-see-through">
                                    <div className="pop-up-image-slider" style={{"transform":"translateX(-" + this.state.content*100 + "%)"}}>
                                        {this.state.video.content.map((e)=>{
                                            return(
                                                <iframe src={e.picture} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            )
                                        })}
                                    </div>
                                    {this.state.video.content.length > 1?<div className="page-indicator">
                                        {this.state.video.content.map((e, i)=>{
                                            return(
                                                <span className={"dot" + (this.state.content === i?" dot-active":"")}></span>
                                            )
                                        })}
                                    </div>:""}
                                </div>
                                <div className={"hotspot-information"}>
                                    <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
                                    <div className={"hotspot-text-holder"}>
                                        <span className="hotspot-header">{this.state.video.content[this.state.content].header}</span>
                                        {
                                            Array.isArray(hotspotText) ? (
                                                hotspotText.map(text => [
                                                    <span className="hotspot-text">{text}</span>, <br/>
                                                ])
                                            ) : (
                                                <span className="hotspot-text">{hotspotText}</span>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </MediaQuery> */}
                </>
            )
        }
        else if(this.state.video.type === "picture"){
            const hotspotText = this.state.video.content[this.state.content].text;

            return(
                <>
                    {/* <MediaQuery maxWidth={950}> */}
                        <CSSTransition in={this.state.hotspotAnim} classNames="vw-hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"vw-hotspot-panel"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="vw-hotspot-wrapper">
                                    <div className="vw-hotspot-image">
                                        {this.state.video.content.map((e)=>{
                                            return(
                                                <img src={e.picture} draggable={false}/>
                                            )
                                        })}
                                    </div>
                                    <div className={"vw-hotspot-information"}>
                                        <div className={"vw-hotspot-text-holder"}>
                                            <h6 className="vw-hotspot-header">{this.state.video.content[this.state.content].header}</h6>
                                            {
                                                Array.isArray(hotspotText) ? (
                                                    hotspotText.map(text => [
                                                        <p className="vw-hotspot-text">{text}</p>, <br/>
                                                    ])
                                                ) : (
                                                    <p className="vw-hotspot-text">{hotspotText}</p>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div
                                        className="vw-hotspot-close-button"
                                        onClick={() => this.setState({ hotspotAnim: false })}
                                    >
                                        <Close />
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    {/* </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"hotspot-panel"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="pop-up-image-see-through">
                                    <div className="pop-up-image-slider" style={{"transform":"translateX(-" + this.state.content*100 + "%)"}}>
                                        {this.state.video.content.map((e)=>{
                                            return(
                                                <img src={e.picture} draggable={false}/>
                                            )
                                        })}
                                    </div>
                                    {this.state.video.content.length > 1?<div className="page-indicator">
                                        {this.state.video.content.map((e, i)=>{
                                            return(
                                                <span className={"dot" + (this.state.content === i?" dot-active":"")}></span>
                                            )
                                        })}
                                    </div>:""}
                                </div>
                                <div className={"hotspot-information"}>
                                    <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
                                    <div className={"hotspot-text-holder"}>
                                        <span className="hotspot-header">{this.state.video.content[this.state.content].header}</span>
                                        {
                                            Array.isArray(hotspotText) ? (
                                                hotspotText.map(text => [
                                                    <span className="hotspot-text">{text}</span>, <br/>
                                                ])
                                            ) : (
                                                <span className="hotspot-text">{hotspotText}</span>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </MediaQuery> */}
                </>
            )
        }
        else if(this.state.video.type === "text"){
            const hotspotText = this.state.video.content[this.state.content].text;

            return(
                <>
                    {/* <MediaQuery maxWidth={950}> */}
                        <CSSTransition in={this.state.hotspotAnim} classNames="vw-hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className="vw-hotspot-panel vw-hotspot-panel-text" onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="vw-hotspot-wrapper">
                                    <div className={"vw-hotspot-information vw-hotspot-information-text"}>
                                        <div className={"vw-hotspot-text-holder"}>
                                            <h6 className="vw-hotspot-header">{this.state.video.content[this.state.content].header}</h6>
                                            {
                                                Array.isArray(hotspotText) ? (
                                                    hotspotText.map(text => [
                                                        <p className="vw-hotspot-text">{text}</p>, <br/>
                                                    ])
                                                ) : (
                                                    <p className="vw-hotspot-text">{hotspotText}</p>
                                                )
                                            }
                                        </div>
                                    </div>
                                    {this.state.video.content.length > 1?<div className="page-indicator">
                                        {this.state.video.content.map((e, i)=>{
                                            return(
                                                <span className={"dot" + (this.state.content === i?" dot-active":"")}></span>
                                            )
                                        })}
                                    </div>:""}

                                    <div
                                        className="vw-hotspot-close-button"
                                        onClick={() => this.setState({ hotspotAnim: false })}
                                    >
                                        <Close />
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    {/* </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"hotspot-panel hotspot-panel-text"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className={"hotspot-information hotspot-information-text"}>
                                    <div className={"hotspot-close"}  onClick={()=>{this.setState({video:null})}}>&times;</div>
                                    <div className={"hotspot-text-holder"}>
                                        <span className="hotspot-header">{this.state.video.content[this.state.content].header}</span>
                                        {
                                            Array.isArray(hotspotText) ? (
                                                hotspotText.map(text => [
                                                    <span className="hotspot-text">{text}</span>, <br/>
                                                ])
                                            ) : (
                                                <span className="hotspot-text">{hotspotText}</span>
                                            )
                                        }
                                    </div>
                                </div>
                                {this.state.video.content.length > 1?<div className="page-indicator">
                                    {this.state.video.content.map((e, i)=>{
                                        return(
                                            <span className={"dot" + (this.state.content === i?" dot-active":"")}></span>
                                        )
                                    })}
                                </div>:""}
                            </div>
                        </CSSTransition>
                    </MediaQuery> */}
                </>
            )
        }
        else if(this.state.video === "QR"){
            return(
                <>
                    {/* <MediaQuery maxWidth={950}> */}
                        <CSSTransition in={this.state.hotspotAnim} classNames="vw-hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"vw-hotspot-panel vw-hotspot-panel-qr"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
                                <div className="vw-hotspot-wrapper">
                                    <div className="vw-hotspot-image">
                                        <img
                                            src={this.state.QRlink}
                                            draggable={false}
                                        />
                                    </div>
                                    <div className={"vw-hotspot-information"}>
                                        <div className={"vw-hotspot-text-holder"}>
                                            <h6 className="vw-hotspot-header">Realidad Aumentada</h6>
                                            <p className="vw-hotspot-text">Escanea el código QR con tu celular para experimentar el {this.state.modelController?this.state.modelController.modelLoadController.getModelName():"Taos"} en Realidad Aumentada.</p>
                                        </div>
                                    </div>

                                    <div
                                        className="vw-hotspot-close-button"
                                        onClick={() => this.setState({ hotspotAnim: false })}
                                    >
                                        <Close />
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    {/* </MediaQuery>
                    <MediaQuery minWidth={950}>
                        <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
                            <div className={"hotspot-panel hotspot-panel-QR"}>
                                <div className="pop-up-image-see-through">
                                    <div className="pop-up-image-slider" style={{"transform":"translateX(-" + this.state.content*100 + "%)"}}>
                                        <img src={this.state.QRlink} draggable={false}/>
                                    </div>
                                </div>
                                <div className={"hotspot-information"}>
                                    <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
                                    <div className={"hotspot-text-holder"}>
                                        <span className="hotspot-header">Realidad Aumentada</span>
                                        <span className="hotspot-text">Escanea el código QR con tu celular para experimentar el Nuevo {this.state.modelController?this.state.modelController.modelLoadController.getModelName():"Taos"} en Realidad Aumentada.</span>
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </MediaQuery> */}
                </>
            );
        }
    }

  render(){
        return(
            <div className="main-holder" id={"main-holder"} style={{ maxHeight: this.state.maxHeight}}>
                {(this.state.loading && !this.state.disclaimer)?
                    <CSSTransition timeout={0} in={this.state.loadingAnim} classNames="loadingAnim" onExited={()=>{setTimeout(()=>{this.setState({loading:false})}, 800)}}>
                        {this.getLoading()}
                    </CSSTransition>:""}
                <div id="scene-canvas"
                     className="scene-canvas"
                     style={{"height":"100%", "width":"100vw"}}
                     onClick={this.state.selectionController.onClick}
                     onMouseDown={this.state.selectionController.onMouseDown}
                     onMouseMove={this.state.selectionController.onMouseMove}></div>
                {this.getMenu()}

                <MenuMainNew
                    presentation={this.presentation.bind(this)}
                    toggleMenu={this.toogleMenu.bind(this)}
                    engine={this.state.engine}
                    selectionController={this.state.selectionController}
                    deviceOrientationCameraController={this.state.deviceOrientationCameraController}
                    arController={this.state.arController}
                    controller3D={this.state.controller3D}
                    modelController={this.state.modelController}
                    hotSpotController={this.state.hotspotController}
                    appendHotspot={this.appendHotspot.bind(this)}
                    highlightAR={this.state.highlightAR}
                    warning={this.state.warning}
                    ARQR={this.generateQR.bind(this)}
                    mediaQueryIpad={this.state.mediaQueryIpad}
                    sequenceController={this.state.sequenceController}
                    drive={()=>{
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        this.state.modelController.drivingAnimationController.start();
                        trackDriving();
                        this.setState({
                            driving:this.state.modelController.drivingAnimationController.enabled
                        })
                    }}
                    hideMenu={(
                        this.state.driving ||
                        this.state.disclaimer ||
                        this.state.groundHotspot ||
                        this.state.screenshot ||
                        this.state.modelSelect ||
                        this.state.trunkLoading ||
                        this.state.genericPassenger ||
                        this.state.xRay ||
                        this.state.sequence ||
                        this.state.isModelLoadIntroAnimationRunning
                    )}
                    screenshotMode={()=>{
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        this.setState({
                            screenshot:true
                        })
                    }}
                    shareService={this.state.webShareController}
                    switchingModel={()=>{this.setState({modelSelect:true})}}
                    trunkLoadingMode={()=>{
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        this.state.trunkLoadingController.enter();
                        this.setState({
                            trunkLoading:true
                        })
                    }}
                    genericPassengerMode={async ()=>{
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        await this.state.genericPassengerController.enter()
                        .then(_ => {
                            this.setState({
                                genericPassenger:true
                            })
                        })
                    }}
                    xRayMode={async ()=>{
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        await this.state.xRayController.enter()
                        .then(_ => {
                            this.setState({
                                xRay:true
                            })
                        })
                    }}
                    sequenceMode={async () => {
                        if(this.state.hotspotController && this.state.hotspotController.visible){
                            this.state.hotspotController.toggleHotspots();
                        }
                        await this.state.sequenceController.playHighlightFly();
                    }}
                    exporting={this.state.exporting}
                    onEnterAR={this.onEnterAR}
                    onLeaveAR={this.onLeaveAR}
                    audioController={this.state.audioController}
                />
                
                {this.getLogo()}
                {this.renderHotspotPopup()}
                {this.state.disclaimer?<Disclaimer
                    configuratorModel={this.state.modelController}
                    close={()=>{
                    this.setState({disclaimer:false})
                    if(this.state.loading){
                        this.load();
                    }
                }}
                preload={this.state.loading}
                />:""}

                {this.renderSequenceCenterLabel()}
            </div>
        )
  }

}

// const HotspotComponent:React.FC<{data:IHotspotData, cIndex:number}> = (props) => {
//     const {data, cIndex} = props;

//     if (!data || (data as any)==="none") return "";
    
//         if(data.type === "video"){
//             const hotspotText = data.content[cIndex].text;

//             return(
//                 <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
//                     <div className={"hotspot-panel"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
//                         <div className="pop-up-image-see-through">
//                             <div className="pop-up-image-slider" style={{"transform":"translateX(-" + this.state.content*100 + "%)"}}>
//                                 {data.content.map((e)=>{
//                                     return(
//                                         <iframe src={e.picture} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
//                                     )
//                                 })}
//                             </div>
//                             {data.content.length > 1?<div className="page-indicator">
//                                 {data.content.map((e, i)=>{
//                                     return(
//                                         <span className={"dot" + (cIndex === i?" dot-active":"")}></span>
//                                     )
//                                 })}
//                             </div>:""}
//                         </div>
//                         <div className={"hotspot-information"}>
//                             <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
//                             <div className={"hotspot-text-holder"}>
//                                 <span className="hotspot-header">{data.content[cIndex].header}</span>
//                                 {
//                                     Array.isArray(hotspotText) ? (
//                                         hotspotText.map(text => [
//                                             <span className="hotspot-text">{text}</span>, <br/>
//                                         ])
//                                     ) : (
//                                         <span className="hotspot-text">{hotspotText}</span>
//                                     )
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                 </CSSTransition>
//             )
//         }
//         else if(data.type === "picture"){
//             const hotspotText =data.content[cIndex].text;

//             return(
//                 <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
//                     <div className={"hotspot-panel"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
//                         <div className="pop-up-image-see-through">
//                             <div className="pop-up-image-slider" style={{"transform":"translateX(-" + this.state.content*100 + "%)"}}>
//                                 {data.content.map((e)=>{
//                                     return(
//                                         <img src={e.picture} draggable={false}/>
//                                     )
//                                 })}
//                             </div>
//                             {data.content.length > 1?<div className="page-indicator">
//                                 {data.content.map((e, i)=>{
//                                     return(
//                                         <span className={"dot" + (cIndex === i?" dot-active":"")}></span>
//                                     )
//                                 })}
//                             </div>:""}
//                         </div>
//                         <div className={"hotspot-information"}>
//                             <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
//                             <div className={"hotspot-text-holder"}>
//                                 <span className="hotspot-header">{data.content[cIndex].header}</span>
//                                 {
//                                     Array.isArray(hotspotText) ? (
//                                         hotspotText.map(text => [
//                                             <span className="hotspot-text">{text}</span>, <br/>
//                                         ])
//                                     ) : (
//                                         <span className="hotspot-text">{hotspotText}</span>
//                                     )
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                 </CSSTransition>
//             )
//         }
//         else if(data.type === "text"){
//             const hotspotText = data.content[cIndex].text;

//             return(
//                 <div className={"hotspot-panel hotspot-panel-text"} onMouseDown={(e)=>{this.onMouseDown(e)}} onMouseMove={(e)=>{this.onMouseMove(e)}} onMouseUp={(e)=>{this.onMouseUp(e)}} onTouchStart={(e)=>{this.onMouseDown(e)}} onTouchMove={(e)=>{this.onMouseMove(e)}} onTouchEnd={(e)=>{this.onMouseUp(e)}}>
//                     <div className={"hotspot-information hotspot-information-text"}>
//                         <div className={"hotspot-close"}  onClick={()=>{this.setState({video:null})}}>&times;</div>
//                         <div className={"hotspot-text-holder"}>
//                             <span className="hotspot-header">{data.content[cIndex].header}</span>
//                             {
//                                 Array.isArray(hotspotText) ? (
//                                     hotspotText.map(text => [
//                                         <span className="hotspot-text">{text}</span>, <br/>
//                                     ])
//                                 ) : (
//                                     <span className="hotspot-text">{hotspotText}</span>
//                                 )
//                             }
//                         </div>
//                     </div>
//                     {data.content.length > 1?<div className="page-indicator">
//                         {data.content.map((e, i)=>{
//                             return(
//                                 <span className={"dot" + (cIndex === i?" dot-active":"")}></span>
//                             )
//                         })}
//                     </div>:""}
//                 </div>
//             )
//         }
//         else if((data as any) === "QR"){
//             return(
//                 <CSSTransition in={this.state.hotspotAnim} classNames="hotspot" timeout={1} onExited={()=>{setTimeout(()=>{this.setState({video:null})},500)}}>
//                     <div className={"hotspot-panel hotspot-panel-QR"}>
//                         <div className="pop-up-image-see-through">
//                             <div className="pop-up-image-slider" style={{"transform":"translateX(-" + cIndex*100 + "%)"}}>
//                                 <img src={this.state.QRlink} draggable={false}/>
//                             </div>
//                         </div>
//                         <div className={"hotspot-information"}>
//                             <div className={"hotspot-close"}  onClick={()=>{this.setState({hotspotAnim:false})}}>&times;</div>
//                             <div className={"hotspot-text-holder"}>
//                                 <span className="hotspot-header">Realidad Aumentada</span>
//                                 <span className="hotspot-text">Escanea el código QR con tu celular para experimentar el Nuevo {this.state.modelController?this.state.modelController.modelLoadController.getModelName():"Taos"} en Realidad Aumentada.</span>
//                             </div>
//                         </div>
//                     </div>
//                 </CSSTransition>
//                 )
//         }
//     }
// }